module.exports = __webpack_public_path__ + "img/store_vip_benefit_active.8921211e.png";